import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { Row, Col } from 'react-bootstrap'
import { useRecoilState } from 'recoil'
import { Controller } from 'react-hook-form'
import { Button, AsyncWrapper } from '/src/components/common'
import { useStores, useCart } from '/src/hooks'
import { userStoreState } from './storeSelectorState'
import { getCloestStore, StoreSelectorLabel } from './util'
import { getRequest } from '/src/httpClient'

import './store_selector.scss'

const formatResults = (results) => {
  if (!results) {
    return []
  }

  return results.map((node) => {
    return {
      ...node,
      label: <StoreSelectorLabel {...node} />,
      value: node.drupal_id
    }
  })
}

const StoreSelectorElement = ({ user, defaultValue, setValue, control, options }) => {
  let value = null
  if (defaultValue) {
    value = {
      ...defaultValue,
      label: <StoreSelectorLabel {...defaultValue} />
    }
  }

  return (
    <div className="store-element">
      <Controller
        name='select_store'
        control={control}
        render={({ field }) => <Select 
          {...field}
          value={value}
          classNamePrefix='store-select'
          options={options}
          onChange={(value) => {
            const { dsap_plant_id } = value

            getRequest(`/api/store/update?s=${dsap_plant_id}`, new AbortController()).then((res) => {
              field.onChange(value)
              setValue(value)
            })
          }}
          isDisabled={user && user.trade_name}
        />}
      />
    </div>
  )
}

export const StoreSelector = (props) => {
  return (
    <AsyncWrapper>
      <StoreSelectorAsync {...props} />
    </AsyncWrapper>
  )
}

export const StoreSelectorAsync = ({ user, control }) => {
  const cart = useCart()
  const [store, setStore] = useRecoilState(userStoreState)

  return <StoreSelectorElementContainer 
    user={user}
    cart={cart} 
    control={control}
    store={store}
    setStore={setStore} />
}

export const StoreSelectorElementContainer = ({ user, cart, control, store, setStore }) => {
  const [isLoading, setIsLoading] = useState(false)
  const stores = formatResults(useStores())

  useEffect(() => {
    if (cart || store) {
      return
    }
    if (!window || !window.navigator) {
      return
    }

    window.navigator.geolocation.getCurrentPosition((position) => {
      const cloestStore = getCloestStore(stores, position)
      setStore({
        name: cloestStore.name,
        drupal_id: cloestStore.drupal_id,
        dsap_plant_id: cloestStore.dsap_plant_id,
        field_mc_store_address: cloestStore.field_mc_store_address,
        field_mc_store_delivery_estimate: cloestStore.field_mc_store_delivery_estimate,
        value: cloestStore.drupal_id,
      })
    })
  }, [cart])

  const handleFindStoreClick = () => {
    if (!'geolocation' in window.navigator) {
      return
    }

    setIsLoading(true)
    window.navigator.geolocation.getCurrentPosition((position) => {
      // Set closest store.
      const closestStore = getCloestStore(stores, position)
      getRequest(`/api/store/update?s=${closestStore.dsap_plant_id}`, new AbortController()).then((res) => {
        setStore(closestStore)
        setIsLoading(false)
      })
    })
  }

  return (
    <Row className="store-element-container d-flex align-items-center">
      <Col sm={8}>
        <StoreSelectorElement
          user={user}
          defaultValue={store} 
          setValue={setStore} 
          control={control} 
          options={stores} />
      </Col>
      <Col sm={4}>
        {user && user.trade_name ? 
          <Button className="find-closest" disabled="disabled">
            Trade store
          </Button>
          :
          <Button className="find-closest" onClick={handleFindStoreClick}>
            { isLoading ? 'Searching' : 'Find Closest'}
          </Button>
        }
      </Col>
    </Row>
  )
}

export default StoreSelector